<template>
  <div class="floating-configurator">
    <div class="theme-toggle" @click="darkMode" title="Toggle theme">
      <div class="knob" :class="{ 'is-dark': this.$store.state.isDarkMode }">
        <svg class="moon" v-if="this.$store.state.isDarkMode" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"/>
        </svg>
        <svg class="sun" v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="5"/>
          <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex"; // Removed mapState to fix the ESLint error
import { activateDarkMode, deactivateDarkMode } from "@/utils/themeMode";
import apiService from '@/apis/apiService';

export default {
  name: "setting_configurator",
  methods: {
    ...mapMutations(["navbarMinimize", "navbarFixed"]),
    ...mapActions(["setColor"]),

    async darkMode() {
      if (this.$store.state.isDarkMode) {
        this.$store.state.isDarkMode = false;
        deactivateDarkMode();
        localStorage.setItem('theme', 0);
        await apiService.apiClient.post("/api/index/updatetheme", { theme: 0 });            
      } else {
        this.$store.state.isDarkMode = true;
        activateDarkMode();
        localStorage.setItem('theme', 1);
        await apiService.apiClient.post("/api/index/updatetheme", { theme: 1 });            
      }
    }
  }
};
</script>

<style scoped>
/* Floating at bottom-right */
.floating-configurator {
  position: fixed;
  bottom: 28px;
  right: 28px; /* Changed from left to right */
  z-index: 99999 !important;
}

.theme-toggle {
  width: 54px;
  height: 32px;
  border-radius: 16px;
  border: 1px solid rgba(150, 150, 150, 0.3);
  background: rgba(120, 120, 120, 0.15);
  backdrop-filter: blur(12px);
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 4px;
  transition: background 0.3s, border-color 0.3s;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

.theme-toggle:hover { background: rgba(120, 120, 120, 0.25); }

.knob {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  display: grid;
  place-items: center;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

.knob.is-dark {
  transform: translateX(22px);
  background: #222;
}

.sun { color: #f59e0b; width: 14px; height: 14px; }
.moon { color: #fff; width: 14px; height: 14px; }

@media(max-width: 600px) {
  .floating-configurator {
    bottom: 84px;
    right: 16px; /* Changed from left to right */
  }
}
</style>